module.exports = __webpack_public_path__ + "img/saudia-3.b149db14.png";